module.exports = __webpack_public_path__ + "img/collection-engagementRingsSolitaire@2x.929b161.jpg";